export const _DATETIME_FORMAT = `YYYY-MM-DDTHH:mm:ssZ`;
export const _DATE_FORMAT = 'YYYY-MM-DD';
const keyRange = (data) => {
    return data.slice(1);
}
export const _MRS_RANGE = [
    {
        no: null,
        title: 'N/A',
    },
    {
        no: 0,
        title: '0',
    },
    {
        no: 1,
        title: '1',
    },
    {
        no: 2,
        title: '2',
    },
    {
        no: 3,
        title: '3',
    },
    {
        no: 4,
        title: '4',
    },
    {
        no: 5,
        title: '5',
    },
    {
        no: 6,
        title: '6',
    }
];
export const _MMT_GRADE_RANGE = [
    {
        no: null,
        title: 'N/A',
    },
    {
        no: 0,
        title: 'Grade 0',
    },
    {
        no: 1,
        title: 'Grade 1',
    },
    {
        no: 2,
        title: 'Grade 2-',
    },
    {
        no: 3,
        title: 'Grade 2',
    },
    {
        no: 4,
        title: 'Grade 2+',
    },
    {
        no: 5,
        title: 'Grade 3-',
    },
    {
        no: 6,
        title: 'Grade 3',
    },
    {
        no: 7,
        title: 'Grade 3+',
    },
    {
        no: 8,
        title: 'Grade 4-',
    },
    {
        no: 9,
        title: 'Grade 4',
    },
    {
        no: 10,
        title: 'Grade 4+',
    },
    {
        no: 11,
        title: 'Grade 5',
    }
];
export const _BOOLEAN_RANGE = [
    {
        no: 0,
        title: 'false',
    },
    {
        no: 1,
        title: 'true',
    }
];
export const _YES_NO_RANGE = [
    {
        no: 0,
        title: 'No',
    },
    {
        no: 1,
        title: 'Yes',
    }
];
export const _Y_N_RANGE = [
    {
        no: 0,
        title: 'N',
    },
    {
        no: 1,
        title: 'Y',
    }
];

export const _MODE_KEY_RANGE = [
    {
        no: 0,
        title: 'active',
        trans: 'exercise.mode.active'
    },
    {
        no: 1,
        title: 'passive',
        trans: 'exercise.mode.passive'
    },
    {
        no: 2,
        title: 'passive measure',
        trans: 'exercise.mode.passive_measure'
    },
    {
        no: 3,
        title: 'active measure',
        trans: 'exercise.mode.active_measure'
    }
];
export const _PART_KEY_RANGE = (()=> {
    const data = [
        {
            no: 0,
            title: 'error',
            trans: 'exercise.position.error',
            value: [
                {
                    rom: undefined,
                    wrong_min_range: undefined,
                    wrong_max_range: undefined,
                    minAngle: 0,
                    minRom: 0,
                    maxRom: 0,
                },
            ]
        },
        {
            no: 1,
            title: 'elbow',
            trans: 'exercise.position.elbow',
            value: [
                {
                    rom: undefined,
                    wrong_min_range: undefined,
                    wrong_max_range: undefined,
                    minAngle: 0,
                    minRom: 0,
                    maxRom: 0,
                },
                {
                    rom: 'rehabilitation.alert_message.elbow_rom',
                    wrong_min_range: 'rehabilitation.alert_message.elbow_wrong_min_range',
                    wrong_max_range: 'rehabilitation.alert_message.elbow_wrong_max_range',
                    minAngle: 0,
                    minRom: 130,
                    maxRom: 140,
                },
            ]
        },
        {
            no: 2,
            title: 'wrist',
            trans: 'exercise.position.wrist',
            value: [
                {
                    rom: undefined,
                    wrong_min_range: undefined,
                    wrong_max_range: undefined,
                    minAngle: 0,
                    minRom: 0,
                    maxRom: 0,
                },
                {
                    rom: 'rehabilitation.alert_message.wrist_rom',
                    wrong_min_range: 'rehabilitation.alert_message.wrist_wrong_min_range',
                    wrong_max_range: 'rehabilitation.alert_message.wrist_wrong_max_range',
                    minAngle: 0,
                    minRom: 50,
                    maxRom: 60,
                },
            ]
        },
        {
            no: 3,
            title: 'knee',
            trans: 'exercise.position.knee',
            value: [
                {
                    rom: undefined,
                    wrong_min_range: undefined,
                    wrong_max_range: undefined,
                    minAngle: 0,
                    minRom: 0,
                    maxRom: 0,
                },
                {
                    rom: 'rehabilitation.alert_message.knee_rom',
                    wrong_min_range: 'rehabilitation.alert_message.knee_wrong_min_range',
                    wrong_max_range: 'rehabilitation.alert_message.knee_wrong_max_range',
                    minAngle: 0,
                    minRom: 70,
                    maxRom: 80,
                },
                {
                    rom: 'rehabilitation.alert_message.pro_knee_rom',
                    wrong_min_range: 'rehabilitation.alert_message.pro_knee_wrong_min_range',
                    wrong_max_range: 'rehabilitation.alert_message.pro_knee_wrong_max_range',
                    minAngle: 0,
                    minRom: 130,
                    maxRom: 140,
                },
            ]
        },
        {
            no: 4,
            title: 'Ankle',
            trans: 'exercise.position.Ankle',
            value: [
                {
                    rom: undefined,
                    wrong_min_range: undefined,
                    wrong_max_range: undefined,
                    minAngle: 0,
                    minRom: 0,
                    maxRom: 0,
                },
                {
                    rom: 'rehabilitation.alert_message.ankle_rom',
                    wrong_min_range: 'rehabilitation.alert_message.ankle_wrong_min_range',
                    wrong_max_range: 'rehabilitation.alert_message.ankle_wrong_max_range',
                    minAngle: 40,
                    minRom: 100,
                    maxRom: 110,
                },
                {
                    rom: 'rehabilitation.alert_message.pro_ankle_rom',
                    wrong_min_range: 'rehabilitation.alert_message.pro_ankle_wrong_min_range',
                    wrong_max_range: 'rehabilitation.alert_message.pro_ankle_wrong_max_range',
                    minAngle: -50,
                    minRom: 10,
                    maxRom: 20,
                },
            ]
        }
    ];
    return {
        data,
        keyRange: keyRange(data)
    }
})();

export const _ELBOW_METHOD_KEY_RANGE = [
    {
        no : 1,
        trans: 'exercise.method.elbow.neutral',
        value: 1
    },
    {
        no : 2,
        trans: 'exercise.method.elbow.pronated',
        value: 2
    },
    {
        no : 3,
        trans: 'exercise.method.elbow.supinated',
        value: 3
    }
];
export const _WRIST_METHOD_KEY_RANGE = [
    {
        no : 1,
        trans: 'exercise.method.wrist.radial',
        value: 1
    },
    {
        no : 2,
        trans: 'exercise.method.wrist.extension',
        value: 2
    },
    {
        no : 3,
        trans: 'exercise.method.wrist.flexion',
        value: 3
    }
];
export const _KNEE_ANKLE_METHOD_KEY_RANGE = [
    {
        no : 0,
        trans: 'exercise.method.kneeAnkle.0',
        value: 0
    },
    {
        no : 1,
        trans: 'exercise.method.kneeAnkle.1',
        value: 1
    },
    {
        no : 2,
        trans: 'exercise.method.kneeAnkle.2',
        value: 2
    },
    {
        no : 3,
        trans: 'exercise.method.kneeAnkle.3',
        value: 3
    },
    {
        no : 4,
        trans: 'exercise.method.kneeAnkle.4',
        value: 4
    },
    {
        no : 5,
        trans: 'exercise.method.kneeAnkle.5',
        value: 5
    },
    {
        no : 6,
        trans: 'exercise.method.kneeAnkle.6',
        value: 6
    },
    {
        no : 7,
        trans: 'exercise.method.kneeAnkle.7',
        value: 7
    },
    {
        no : 8,
        trans: 'exercise.method.kneeAnkle.8',
        value: 8
    },
    {
        no : 9,
        trans: 'exercise.method.kneeAnkle.9',
        value: 9
    },
];

export const _DIRECTION_KEY_RANGE = (()=>{
    const data = [
        {
            no: 0,
            title: 'error',
            trans: 'exercise.direction.error'
        },
        {
            no: 1,
            title: 'left',
            trans: 'exercise.direction.left'
        },
        {
            no: 2,
            title: 'right',
            trans: 'exercise.direction.right'
        }
    ];
    return {
        data,
        keyRange : keyRange(data)
    }
})();
export const _SPEED_KEY_RANGE = (()=>{
    const data = [
        {
            no: 1,
            title: '1',
            unit : 'unit.passive.unit'
        },
        {
            no: 2,
            title: '2',
            unit : 'unit.passive.unit'
        },
        {
            no: 3,
            title: '3',
            unit : 'unit.passive.unit'
        },
        {
            no: 4,
            title: '4',
            unit : 'unit.passive.unit'
        },
        {
            no: 5,
            title: '5',
            unit : 'unit.passive.unit'
        },
        {
            no: 6,
            title: '6',
            unit : 'unit.passive.unit'
        },
        {
            no: 7,
            title: '7',
            unit : 'unit.passive.unit'
        },
        {
            no: 8,
            title: '8',
            unit : 'unit.passive.unit'
        },
        {
            no: 9,
            title: '9',
            unit : 'unit.passive.unit'
        },
        {
            no: 10,
            title: '10',
            unit : 'unit.passive.unit'
        }
    ];
    return {
        data,
        keyRange : keyRange(data),
        getItemByNo : function (no){
            return data.find( (it) => {return it.no === no} );
        }
    }
})();
export const _DEVICE_HEIGHT_KEY_RANGE = [
        {
            no: 0,
            title: '0',
        },
        {
            no: 1,
            title: '1',
        },
        {
            no: 2,
            title: '2',
        },
        {
            no: 3,
            title: '3',
        },
        {
            no: 4,
            title: '4',
        },
        {
            no: 5,
            title: '5',
        },
        {
            no: 6,
            title: '6',
        },
        {
            no: 7,
            title: '7',
        },
        {
            no: 8,
            title: '8',
        },
        {
            no: 9,
            title: '9',
        }
    ];
export const _ACTIVE_ASSIST_KEY_RANGE = (() => {
    const data = [
        {
            no: -10,
            title: '10',
            unit: 'unit.assist.resist'
        },
        {
            no: -9,
            title: '9',
            unit: 'unit.assist.resist'
        },
        {
            no: -8,
            title: '8',
            unit: 'unit.assist.resist'
        },
        {
            no: -7,
            title: '7',
            unit: 'unit.assist.resist'
        },
        {
            no: -6,
            title: '6',
            unit: 'unit.assist.resist'
        },
        {
            no: -5,
            title: '5',
            unit: 'unit.assist.resist'
        },
        {
            no: -4,
            title: '4',
            unit: 'unit.assist.resist'
        },
        {
            no: -3,
            title: '3',
            unit: 'unit.assist.resist'
        },
        {
            no: -2,
            title: '2',
            unit: 'unit.assist.resist'
        },
        {
            no: -1,
            title: '1',
            unit: 'unit.assist.resist'
        },
        {
            no: 1,
            title: '1',
            unit: 'unit.assist.assist'
        },
        {
            no: 2,
            title: '2',
            unit: 'unit.assist.assist'
        },
        {
            no: 3,
            title: '3',
            unit: 'unit.assist.assist'
        },
        {
            no: 4,
            title: '4',
            unit: 'unit.assist.assist'
        },
        {
            no: 5,
            title: '5',
            unit: 'unit.assist.assist'
        },
        {
            no: 6,
            title: '6',
            unit: 'unit.assist.assist'
        },
        {
            no: 7,
            title: '7',
            unit: 'unit.assist.assist'
        },
        {
            no: 8,
            title: '8',
            unit: 'unit.assist.assist'
        },
        {
            no: 9,
            title: '9',
            unit: 'unit.assist.assist'
        },
        {
            no: 10,
            title: '10',
            unit: 'unit.assist.assist'
        }
    ];
    return {
        data,
        keyRange : (() => {
            return [
                {
                    no: -10,
                    title: '10',
                    unit: 'unit.assist.resist'
                },
                {
                    no: -9,
                    title: '9',
                    unit: 'unit.assist.resist'
                },
                {
                    no: -8,
                    title: '8',
                    unit: 'unit.assist.resist'
                },
                {
                    no: -7,
                    title: '7',
                    unit: 'unit.assist.resist'
                },
                {
                    no: -6,
                    title: '6',
                    unit: 'unit.assist.resist'
                },
                {
                    no: -5,
                    title: '5',
                    unit: 'unit.assist.resist'
                },
                {
                    no: -4,
                    title: '4',
                    unit: 'unit.assist.resist'
                },
                {
                    no: -3,
                    title: '3',
                    unit: 'unit.assist.resist'
                },
                {
                    no: -2,
                    title: '2',
                    unit: 'unit.assist.resist'
                },
                {
                    no: -1,
                    title: '1',
                    unit: 'unit.assist.resist'
                },
                {
                    no: 0,
                    title: '0',
                    unit: 'unit.assist.nature'
                },
                {
                    no: 1,
                    title: '1',
                    unit: 'unit.assist.assist'
                },
                {
                    no: 2,
                    title: '2',
                    unit: 'unit.assist.assist'
                },
                {
                    no: 3,
                    title: '3',
                    unit: 'unit.assist.assist'
                },
                {
                    no: 4,
                    title: '4',
                    unit: 'unit.assist.assist'
                },
                {
                    no: 5,
                    title: '5',
                    unit: 'unit.assist.assist'
                },
                {
                    no: 6,
                    title: '6',
                    unit: 'unit.assist.assist'
                },
                {
                    no: 7,
                    title: '7',
                    unit: 'unit.assist.assist'
                },
                {
                    no: 8,
                    title: '8',
                    unit: 'unit.assist.assist'
                },
                {
                    no: 9,
                    title: '9',
                    unit: 'unit.assist.assist'
                },
                {
                    no: 10,
                    title: '10',
                    unit: 'unit.assist.assist'
                },
            ];
        })(),
        getItemByNo : function (no){
            return data.find( (it) => {return it.no === no} );
        }
    };
})();

export const _STATUS_KEY_RANGE = [
    {
        title: 'assigned',
        class: 'txt_waiting txt_bold',
        trans: 'status.assigned'
    },
    {
        title: 'terminated',
        class: 'txt_red txt_bold',
        trans: 'status.terminated'
    },
    {
        title: 'accomplished_manual',
        class: 'txt_blue txt_bold',
        trans: 'status.accomplished_manual'
    },
    {
        title: 'accomplished_auto',
        class: 'txt_blue txt_bold',
        trans: 'status.accomplished_auto'
    },
    {
        title: 'on_progress',
        class: 'txt_green txt_bold',
        trans: 'status.on_progress'
    },
    {
        title: 'past_due',
        class: 'txt_cancel txt_bold',
        trans: 'status.past_due'
    }
];
export const _EQUIPMENT_KEY_RANGE = (()=> {
    const data = [
        {
            no: 0,
            title: 'error',
            trans: 'device_type.error'
        }, {
            no: 1,
            title: 'Rebless_home',
            trans: 'device_type.rebless_home'
        }
        , {
            no: 2,
            title: 'Rebless_pro',
            trans: 'device_type.rebless_pro'
        }
        ];
    return {
        data,
        keyRange : keyRange(data)
    }
})();
export const _RMC_STATUS_KEY_RANGE = [
    {
        no: 0,
        title: 'waiting',
        class: 'status_waiting',
        status: 'status_waiting'
    },
    {
        no: 1,
        title: 'done',
        class: 'status_waiting',
        status: 'status_waiting'
    },
    {
        // 수동 취소
        no: 2,
        title: 'canceled',
        class: 'status_waiting',
        status: 'status_waiting'
    },
    {
        no: 3,
        title: 'start',
        class: 'status_start',
        status: 'status_start'
    },
    {
        // 자동 취소
        no: 4,
        title: 'canceled',
        class: 'status_waiting',
        status: 'status_waiting'
    }
];

export const _START_TIME_RANGE = [
    {no: 1,title: '07:00 AM', value: '07:00'},
    {no: 2,title: '07:15 AM', value: '07:15'},
    {no: 3,title: '07:30 AM', value: '07:30'},
    {no: 4,title: '07:45 AM', value: '07:45'},
    {no: 5,title: '08:00 AM', value: '08:00'},
    {no: 6,title: '08:15 AM', value: '08:15'},
    {no: 7,title: '08:30 AM', value: '08:30'},
    {no: 8,title: '08:45 AM', value: '08:45'},
    {no: 9,title: '09:00 AM', value: '09:00'},
    {no: 10,title: '09:15 AM', value: '09:15'},
    {no: 11,title: '09:30 AM', value: '09:30'},
    {no: 12,title: '09:45 AM', value: '09:45'},
    {no: 13,title: '10:00 AM', value: '10:00'},
    {no: 14,title: '10:15 AM', value: '10:15'},
    {no: 15,title: '10:30 AM', value: '10:30'},
    {no: 16,title: '10:45 AM', value: '10:45'},
    {no: 17,title: '11:00 AM', value: '11:00'},
    {no: 18,title: '11:15 AM', value: '11:15'},
    {no: 19,title: '11:30 AM', value: '11:30'},
    {no: 20,title: '11:45 AM', value: '11:45'},
    {no: 21,title: '12:00 PM', value: '12:00'},
    {no: 22,title: '12:15 PM', value: '12:15'},
    {no: 23,title: '12:30 PM', value: '12:30'},
    {no: 24,title: '12:45 PM', value: '12:45'},
    {no: 25,title: '01:00 PM', value: '13:00'},
    {no: 26,title: '01:15 PM', value: '13:15'},
    {no: 27,title: '01:30 PM', value: '13:30'},
    {no: 28,title: '01:45 PM', value: '13:45'},
    {no: 29,title: '02:00 PM', value: '14:00'},
    {no: 30,title: '02:15 PM', value: '14:15'},
    {no: 31,title: '02:30 PM', value: '14:30'},
    {no: 32,title: '02:45 PM', value: '14:45'},
    {no: 33,title: '03:00 PM', value: '15:00'},
    {no: 34,title: '03:15 PM', value: '15:15'},
    {no: 35,title: '03:30 PM', value: '15:30'},
    {no: 36,title: '03:45 PM', value: '15:45'},
    {no: 37,title: '04:00 PM', value: '16:00'},
    {no: 38,title: '04:15 PM', value: '16:15'},
    {no: 39,title: '04:30 PM', value: '16:30'},
    {no: 40,title: '04:45 PM', value: '16:45'},
    {no: 41,title: '05:00 PM', value: '17:00'},
    {no: 42,title: '05:15 PM', value: '17:15'},
    {no: 43,title: '05:30 PM', value: '17:30'},
    {no: 44,title: '05:45 PM', value: '17:45'},
    {no: 45,title: '06:00 PM', value: '18:00'},
    {no: 46,title: '06:15 PM', value: '18:15'},
    {no: 47,title: '06:30 PM', value: '18:30'},
    {no: 48,title: '06:45 PM', value: '18:45'},
    {no: 49,title: '07:00 PM', value: '19:00'},
    {no: 50,title: '07:15 PM', value: '19:15'},
    {no: 51,title: '07:30 PM', value: '19:30'},
    {no: 52,title: '07:45 PM', value: '19:45'},
    {no: 53,title: '08:00 PM', value: '20:00'},
    {no: 54,title: '08:15 PM', value: '20:15'},
    {no: 55,title: '08:30 PM', value: '20:30'},
    {no: 56,title: '08:45 PM', value: '20:45'}

    // {no: 1,title: '00:00'},
    // {no: 2,title: '00:15'},
    // {no: 3,title: '00:30'},
    // {no: 4,title: '00:45'},
    // {no: 5,title: '01:00'},
    // {no: 6,title: '01:15'},
    // {no: 7,title: '01:30'},
    // {no: 8,title: '01:45'},
    // {no: 9,title: '02:00'},
    // {no: 10,title: '02:15'},
    // {no: 11,title: '02:30'},
    // {no: 12,title: '02:45'},
    // {no: 13,title: '03:00'},
    // {no: 14,title: '03:15'},
    // {no: 15,title: '03:30'},
    // {no: 16,title: '03:45'},
    // {no: 17,title: '04:00'},
    // {no: 18,title: '04:15'},
    // {no: 19,title: '04:30'},
    // {no: 20,title: '04:45'},
    // {no: 21,title: '05:00'},
    // {no: 22,title: '05:15'},
    // {no: 23,title: '05:30'},
    // {no: 24,title: '05:45'},
    // {no: 25,title: '06:00'},
    // {no: 26,title: '06:15'},
    // {no: 27,title: '06:30'},
    // {no: 28,title: '06:45'},
    // {no: 29,title: '07:00'},
    // {no: 30,title: '07:15'},
    // {no: 31,title: '07:30'},
    // {no: 32,title: '07:45'},
    // {no: 33,title: '08:00'},
    // {no: 34,title: '08:15'},
    // {no: 35,title: '08:30'},
    // {no: 36,title: '08:45'},
    // {no: 37,title: '09:00'},
    // {no: 38,title: '09:15'},
    // {no: 39,title: '09:30'},
    // {no: 40,title: '09:45'},
    // {no: 41,title: '10:00'},
    // {no: 42,title: '10:15'},
    // {no: 43,title: '10:30'},
    // {no: 44,title: '10:45'},
    // {no: 45,title: '11:00'},
    // {no: 46,title: '11:15'},
    // {no: 47,title: '11:30'},
    // {no: 48,title: '11:45'},
    // {no: 49,title: '12:00'},
    // {no: 50,title: '12:15'},
    // {no: 51,title: '12:30'},
    // {no: 52,title: '12:45'},
    // {no: 53,title: '13:00'},
    // {no: 54,title: '13:15'},
    // {no: 55,title: '13:30'},
    // {no: 56,title: '13:45'},
    // {no: 57,title: '14:00'},
    // {no: 58,title: '14:15'},
    // {no: 59,title: '14:30'},
    // {no: 60,title: '14:45'},
    // {no: 61,title: '15:00'},
    // {no: 62,title: '15:15'},
    // {no: 63,title: '15:30'},
    // {no: 64,title: '15:45'},
    // {no: 65,title: '16:00'},
    // {no: 66,title: '16:15'},
    // {no: 67,title: '16:30'},
    // {no: 68,title: '16:45'},
    // {no: 69,title: '17:00'},
    // {no: 70,title: '17:15'},
    // {no: 71,title: '17:30'},
    // {no: 72,title: '17:45'},
    // {no: 73,title: '18:00'},
    // {no: 74,title: '18:15'},
    // {no: 75,title: '18:30'},
    // {no: 76,title: '18:45'},
    // {no: 77,title: '19:00'},
    // {no: 78,title: '19:15'},
    // {no: 80,title: '19:30'},
    // {no: 81,title: '19:45'},
    // {no: 82,title: '20:00'},
    // {no: 83,title: '20:15'},
    // {no: 84,title: '20:30'},
    // {no: 85,title: '20:45'},
    // {no: 86,title: '21:00'},
    // {no: 87,title: '21:15'},
    // {no: 88,title: '21:30'},
    // {no: 89,title: '21:45'},
    // {no: 90,title: '22:00'},
    // {no: 91,title: '22:15'},
    // {no: 92,title: '22:30'},
    // {no: 93,title: '22:45'},
    // {no: 94,title: '23:00'},
    // {no: 95,title: '23:15'},
    // {no: 96,title: '23:30'},
    // {no: 97,title: '23:45'},
    // {no: 98,title: '24:00'},
];

export const _PROGRESS_TIME_RANGE = [
    {
        no: 1,
        title: '15',
        value: '00:15:00',
        unit: 'unit.mins'
    },
    {
        no: 2,
        title: '30',
        value: '00:30:00',
        unit: 'unit.mins'
    },
    {
        no: 2,
        title: '45',
        value: '00:45:00',
        unit: 'unit.mins'
    },
    {
        no: 2,
        title: '60',
        value: '01:00:00',
        unit: 'unit.mins'
    }
];

export const _BRAIN_LESION_RANGE = [
    {
        no: 0,
        trans: 'unit.brain_lesion.unset',
    },
    {
        no: 1,
        trans: 'unit.brain_lesion.grade1',
    },
    {
        no: 2,
        trans: 'unit.brain_lesion.grade2',
    },
    {
        no: 3,
        trans: 'unit.brain_lesion.grade3',
    },
    {
        no: 4,
        trans: 'unit.brain_lesion.grade4',
    },
    {
        no: 5,
        trans: 'unit.brain_lesion.grade5',
    },
    {
        no: 6,
        trans: 'unit.brain_lesion.grade6',
    },
    {
        no: 7,
        trans: 'unit.brain_lesion.severe',
    },
    {
        no: 8,
        trans: 'unit.brain_lesion.mild',
    }
];

